var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheriff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#004DB0"
    },
    cx: 255.996,
    cy: 255.996,
    r: 255.996
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003D8D"
    },
    d: "M512,255.999c0-14.199-1.174-28.121-3.398-41.691l-68.729-68.729 c-3.851-4.501-9.563-7.363-15.95-7.363c-11.597,0-20.998,9.401-20.998,20.998c0,0.444,0.017,0.884,0.044,1.321l-17.926,1.27 L273.167,50.032c-3.8-5.396-10.065-8.93-17.166-8.93c-11.597,0-20.998,9.401-20.998,20.998c0,7.093,3.532,13.339,8.919,17.136 c0.709,1.007,1.503,1.95,2.374,2.816l-31.628,64.998c-11.809,4.483-22.701,10.827-32.315,18.679l-62.674-4.441l-14.433-14.143 c-3.8-5.396-10.065-8.931-17.166-8.931c-11.596,0-20.998,9.401-20.998,20.998c0,7.101,3.535,13.366,8.931,17.166l64.437,64.813 c-0.618,4.85-0.951,9.788-0.951,14.806c0,6.354,0.516,12.586,1.495,18.664L99.951,335.39c-3.377-2.321-7.464-3.684-11.871-3.684 c-11.596,0-20.998,9.401-20.998,20.998c0,7.101,3.535,13.367,8.931,17.166l138.815,138.818c13.406,2.168,27.154,3.312,41.173,3.312 C397.385,512,512,397.385,512,255.999z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9A00"
    },
    points: "256.004,62.099 307.203,167.32 423.926,159.05 358.402,255.999 423.926,352.95  307.203,344.68 256.004,449.899 204.804,344.68 88.082,352.95 153.605,255.999 88.082,159.05 204.804,167.32 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8800"
    },
    points: "371.013,274.65 423.929,352.949 329.65,346.268 307.203,344.683 297.341,364.938  265.181,431.025 256.001,449.897 256.001,62.103 265.181,80.975 297.341,147.062 307.203,167.317 329.65,165.732 423.929,159.051  371.013,237.35 358.406,255.999 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDBA9"
    },
    cx: 255.996,
    cy: 255.996,
    r: 116.504
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC473"
    },
    d: "M256.001,139.496v233.008c64.345,0.002,116.503-52.16,116.503-116.504 S320.345,139.494,256.001,139.496z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDC000"
    },
    cx: 255.996,
    cy: 255.996,
    r: 84.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB300"
    },
    d: "M340.746,255.999c0,46.81-37.937,84.746-84.746,84.746V171.254 C302.809,171.254,340.746,209.191,340.746,255.999z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDBA9"
    },
    cx: 255.996,
    cy: 62.097,
    r: 21.002
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC473"
    },
    d: "M277.001,62.103c0,8.309-4.819,15.479-11.82,18.873c-2.776,1.361-5.894,2.117-9.181,2.117v-41.99 C267.596,41.103,277.001,50.507,277.001,62.103z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDBA9"
    },
    cx: 255.996,
    cy: 449.895,
    r: 21.002
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC473"
    },
    d: "M277.001,449.897c0,11.596-9.404,21-21,21v-41.991c3.287,0,6.404,0.755,9.181,2.117 C272.182,434.418,277.001,441.588,277.001,449.897z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC473"
    },
    cx: 423.919,
    cy: 159.209,
    r: 21.002
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDBA9"
    },
    cx: 88.073,
    cy: 159.209,
    r: 21.002
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC473"
    },
    cx: 423.919,
    cy: 352.7,
    r: 21.002
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDBA9"
    },
    cx: 88.073,
    cy: 352.7,
    r: 21.002
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9A00"
    },
    points: "256.004,188.101 277.08,226.99 320.58,235.018 290.107,267.08 295.914,310.932  256.004,291.858 216.093,310.932 221.901,267.08 191.427,235.018 234.926,226.99 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8800"
    },
    points: "290.107,267.086 295.916,310.937 256.001,291.862 256.001,188.105 277.075,226.988  320.575,235.021 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheriff);
export default __webpack_public_path__ + "static/media/sheriff.fe16bc1e1eac90a9123cdf8f410b68ab.svg";
export { ForwardRef as ReactComponent };